import React from 'react';

const ListCircleBoldIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#8B62FF" fillOpacity="0.1" />
    <path d="M24 16.8L15.75 16.8" stroke="#8B62FF" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M28.2031 26.6985L15.7531 26.6985" stroke="#8B62FF" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M32.1016 21.7493L15.7516 21.7493" stroke="#8B62FF" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M21.4531 31.6516L15.7531 31.6516" stroke="#8B62FF" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default ListCircleBoldIcon;
